export interface LegendDataIconProps {
  fill: string;
  type?: "minus" | "square";
}

export function LegendDataIcon({ fill, type = "square" }: LegendDataIconProps): React.ReactNode {
  return (
    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" width={12} height={12} viewBox="-5 -5 10 10">
      {type === "minus" && <rect x={-5} y={0} width={10} height={2} rx="1" fill={fill} />}
      {type === "square" && <rect x={-4} y={-4} width={8} height={8} rx="2" fill={fill} />}
    </svg>
  );
}
